import { createSelector } from 'reselect';
import mergeChangesWithAppointment from '../helpers/appointment-changes-merge';
// import mergeChangesWithBock from '../helpers/bock-changes-merge';

const appointmentsSelector = state => state.tasks.appointments;
const endeteredDataSelector = state => state.tasks.enteredData;
const selectedAppSelector = state => state.tasks.selectedAppointmentId;
const selectedPersonSelector = state => state.tasks.selectedPersonId;
const nextPersonId = state => state.tasks.nextPersonId;
// const selectedAppServiceIDSelector = state => state.tasks.selectedAppointmentServiceID;
const attachmentsSelector = state => state.tasks.attachments;
// const notesSelector = state => state.tasks.notes;
const fotosSelector = state => state.tasks.fotos;
const positionsSelector = state => state.tasks.positions;
const personsSelector = state => state.tasks.persons;
const bocksSelector = state => state.tasks.bocks;
const selectedCompanyId = state => state.tasks.selectedCompanyId;
const settings = state =>  state.settings;
const filterInfo = state => state.tasks.shownType;
// const selectedBockSelector = state => state.tasks.selectedBockId;

const getSelectedAppointment = (appointments, enteredData, UniqueID) => {

    const uID = parseInt(UniqueID) === -1 ? null : parseInt(UniqueID);
    //const uID = appointments.length !== 0 ? appointments[0].UniqueID : null;

    let app = appointments.find(app => app.UniqueID === uID);
    if (!app) return {};
    const modifiedData = enteredData.find(c => c.UniqueID === uID);
    if (!modifiedData) return app;

    return mergeChangesWithAppointment(app, modifiedData);
}


const SelectedAppSelector = createSelector(
    appointmentsSelector,
    endeteredDataSelector,
    selectedAppSelector,
    getSelectedAppointment
);

const getSelectedAppointmentPositions = (positions, UniqueID, appointments, enteredData) => {
    // console.log("Selector positions: ", positions);
    let app = appointments.find(c => c.UniqueID === parseInt(UniqueID));
    if (!app) return [];
    let auftargNr = app.AuftragNr;
    let sorted = positions.filter(c => c.AuftragId === auftargNr);
    if (enteredData.length === 0) {
        return sorted;
    } else {
        return sorted.map(row => {
            let ed = enteredData.find(e => e.UniqueID === parseInt(UniqueID));
            if (ed) {
                if (ed.hasOwnProperty("Positions")) {
                    let update = ed.Positions.find(e => e.Position === row.Position);
                    if (update) {
                        row.Selected = update.Selected;
                        return row;
                    }
                }
            }


            return row;
        })
    }
}


const SelectedAppPositionsSelector = createSelector(
    positionsSelector,
    selectedAppSelector,
    appointmentsSelector,
    endeteredDataSelector,
    getSelectedAppointmentPositions
);

const getSelectedAppintmentMonteure = (persons, appointments, UniqueID, enteredData) => {

    //let personsCombined = Object.assign({}, persons, enteredData.Persons);

    const uID = parseInt(UniqueID) === -1 ? null : parseInt(UniqueID);
    let app = appointments.find(c => c.UniqueID === uID);
    if (!app) return [];
    return getSelectedAppointmentKundenNr(app, persons);
}

const getSelectedAppointmentKundenNr = (app, persons) => {
    return persons.filter(c => c.Kunden_Nr === app.Kunden_Nr);
}

const SelectedAppMonteureSelector = createSelector(
    personsSelector,
    appointmentsSelector,
    selectedAppSelector,
    endeteredDataSelector,
    getSelectedAppintmentMonteure
);

const getSelectedPerson = (persons, id, UniqueID, enteredData, nextPersonId) => {
    let retVal = persons.filter(c => c.id === parseInt(id));
    let obj = [];
    // if (!retVal) return [];
    const modifiedData = enteredData.find(c => c.UniqueID === parseInt(UniqueID));
    //Novi monteri
    if (retVal.length === 0 && id === "-1") {
        if (modifiedData) {
            if (modifiedData.hasOwnProperty("Persons")) {
                let newMonteur = modifiedData.Persons.find(e => e.id === nextPersonId);
                if (newMonteur) return newMonteur;
                return { Name: "", Vorname: "", Tel_1: "" };
            } else {
                return { Name: "", Vorname: "", Tel_1: "" };
            }
        }
    }
    //Edit postojećih montera
    //Kada nema editovanih podataka za postojeće montere, vrati prvog odgovarajućeg iz tabele persons
    if (!modifiedData) return retVal[0];
    //Vraćanje editovanih podataka za montera.
    if (modifiedData && modifiedData.hasOwnProperty("Persons")) obj = (modifiedData.Persons);
    let t = obj.find(e => e.id === parseInt(id));
    if (!t) return retVal[0];
    return t;

}

const SelectedAppMonteure = createSelector(
    personsSelector,
    selectedPersonSelector,
    selectedAppSelector,
    endeteredDataSelector,
    nextPersonId,
    getSelectedPerson
)

const getSelectedAppointmentAttachments = (attachments, UniqueID) => {
    return attachments.filter(c => c.id === parseInt(UniqueID));
}
const SelectedAppAttachmentsSelector = createSelector(
    attachmentsSelector,
    selectedAppSelector,
    getSelectedAppointmentAttachments
);



const getSelectedCompanyAttachments = (appointments, attachments, IdFirma) => {

      return attachments.filter(app => {
          return appointments.some(value => {
              return value.AuftragNr === app.AuftragNr && value.IdFirma === IdFirma
          })
      });


    //console.log(test);
}
const SelectedCompanyAttachmentSelector = createSelector(
    appointmentsSelector,
    attachmentsSelector,
    selectedCompanyId,
    getSelectedCompanyAttachments
);

// const getSelectedAppointmentNotes = (notes, IDService ) => {
//     return notes.filter(c=>c.ServiceID===parseInt(IDService));
// }
// const SelectedAppNotesSelector = createSelector(
//     notesSelector,
//     selectedAppServiceIDSelector,
//     getSelectedAppointmentNotes
// );

const getSelectedAppointmentPhotos = (photos, UniqueID) => {
    const uID = parseInt(UniqueID) === -1 ? null : parseInt(UniqueID);
    return photos.filter(c => c.UniqueID === uID);
}

const SelectedAppPhotosSelector = createSelector(
    fotosSelector,
    selectedAppSelector,
    getSelectedAppointmentPhotos
);

const getSelectedBock = (bocks, enteredData, UniqueID) => {

    const uID = parseInt(UniqueID) === -1 ? null : parseInt(UniqueID);
    //const uID = UniqueID === -1 ? null : UniqueID;
    // za sada selektuje samo po Kunden_Nr , posto nema mnogo podataka - promjeniti kasnije u AuftragNr ili ID

    let app = bocks.filter(app => app.UniqueID === uID);
    if (!app) return {};
    return app;
    // const modifiedData = enteredData.find(c => c.id === uID);
    // if (!modifiedData) return app;

    // // napraviti merge kasnije
    // return mergeChangesWithBock(app, modifiedData);
}

const SelectedBockSelector = createSelector(
    bocksSelector,
    endeteredDataSelector,
    selectedAppSelector,
    getSelectedBock
);

export {
    SelectedAppSelector,
    SelectedAppPositionsSelector,
    bocksSelector,
    SelectedAppMonteureSelector,
    SelectedAppMonteure,
    SelectedAppAttachmentsSelector,
    SelectedAppPhotosSelector,
    SelectedBockSelector,
    SelectedCompanyAttachmentSelector,
    settings,
    filterInfo
}
